<div class="tile-wrapper tile-wrapper--{{block.data.style || 'style1'}}" [swiper]="slideConfig">
    <div class="tile-container">
        <div *ngFor="let block of block.content; trackBy: trackByFn; let isFirst = first;"
             [ngStyle]="{backgroundImage: block.data.image && isStyle2 ? 'url(' + block.data.image + ')' : null}"
             class="tile-item"
             [ngClass]="{'tile-item--has-image': block.data.image, 'tile-item--no-image': !block.data.image}">
            <div class="tile-caption__image" *ngIf="block.data.image && isStyle4"
                 [ngStyle]="{backgroundImage: 'url(' + block.data.image + ')'}"></div>
            <div class="tile-caption">
                <div class="tile-caption__content">
                    <h3 *ngIf="isStyle5 && isFirst" class="tile-caption__header"><abbr
                            title="Frequently Asked Question">FAQ</abbr></h3>
                    <span [outerHTML]="block.data.content"></span>
                    <a href="{{block.data.url}}" *ngIf="block.data.buttonText"
                       class="btn btn-primary tile-caption__button">{{block.data.buttonText}}</a>
                </div>
            </div>
        </div>
    </div>

    <div class="tile-controls">
        <div class="tile-controls__prev"></div>
        <div class="tile-controls__indicator-wrapper"></div>
        <div class="tile-controls__next"></div>
    </div>
</div>
